import { getQaSelector } from '../../../../utils/common'
import { UserListItem } from '../../../ListItem'
import Text from '../../../Text'

import * as styles from './EmailPreviewUserField.module.css'

function EmailPreviewUserField({ label, option, qaName }) {
  const qaProps = getQaSelector({
    value: qaName,
  })

  return (
    <div {...qaProps} className={styles.field}>
      <Text isSecondary className={styles.label}>
        {label}
      </Text>
      <UserListItem value={option} />
    </div>
  )
}

export default EmailPreviewUserField
